<template>
  <div class="searchWithFilters">
    <v-text-field
      v-if="showTextField"
      ref="teamSearchInput"
      v-model="search"
      v-autofocus
      clearable
      color="primary"
      class="customSearch"
      hideDetails
      prependInnerIcon="search"
      :appendIcon="filters.length ? 'filter_list' : undefined"
      flat
      solo
      backgroundColor="lightgreen"
      :placeholder="searchPlaceholder"
      height="56px"
      data-cy="searchBar"
      @click:append="onFilterClick"
      @input="debouncedSearch"
    />
    <v-row
      v-if="!withoutFilter"
      v-show="filtersVisible"
      class="filter--input__container"
      align="center"
    >
      <v-col
        v-for="item in mutableFilters"
        :key="item.key"
        cols="auto"
        class="p-0 blocFiltreAR"
      >
        <v-select
          v-if="item.type === 'select'"
          v-model="item.value"
          :label="$t(item.label)"
          dense
          outlined
          prependInnerIcon="filter_list"
          class="filter--input single-line-select"
          :items="item.items"
          :itemText="item => !item.isAlreadyTranslated ? $t(item.text) : item.text"
          :multiple="item.multiple"
          :clearable="!!item.clearable"
          :data-cy="item.dataCY"
        />
        <v-switch
          v-else-if="item.type === 'switch'"
          v-model="item.value"
          style="margin-top: 0px; padding-top: 0px; margin-right: 5px;"
          :label="$t('clients.labels.switchActiveInactive')"
          hideDetails
        />
        <div
          v-else-if="item.type === 'date' && hasDatesRange"
          class="filter--date"
        >
          <v-col
            cols="12"
            class="blocFiltreAR__date"
          >
            <v-menu
              ref="menu"
              v-model="isMenuOpen"
              :closeOnContentClick="false"
              transition="scale-transition"
              offsetY
              minWidth="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('generic.dateRange')"
                  prependInnerIcon="event"
                  readonly
                  outlined
                  :hideDetails="true"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="item.value"
                :label="$t(item.label)"
                range
                :max="$utils.getTomorrowDate()"
                color="#26384B"
              />
            </v-menu>
          </v-col>
        </div>
        <div
          v-else-if="item.type === 'date' && !hasDatesRange"
          class="filter--date"
        >
          <VDate
            v-model="item.value"
            :value="item.value"
            :label="$t(item.label)"
            :isRange="item.isRange"
            :dateMonth="isDateMonth"
            dense
            :data-cy="item.dataCY"
          />
        </div>

        <div
          v-else-if="item.type === 'dateWithCheckbox'"
          style="display: flex;height: 100%; top: 0;"
        >
          <v-checkbox
            v-model="samplesReceivedCheckBoxValue"
            class="mr-3"
            :label="$t('laboratory.labels.isReceived')"
            :data-cy="'checkbox-' + item.key"
            style="margin: 5px 40px 30px 20px !important;"
            @change="samplesReceivedChanged"
          />
          <VDate
            v-if="samplesReceivedCheckBoxValue"
            v-model="item.value"
            :value="item.value"
            :label="$t(item.label)"
            :isRange="true"
            dense
            :data-cy="item.dataCY"
            style="margin-right:20px !important;"
          />
        </div>

        <v-btn
          v-else-if="item.key === 'search' && filters.length && filterName !== 'PricingManagement'"
          :text="item.value"
          style="margin-right: 5px; margin-bottom: 30px"
          class="white--text"
          color="#26384B"
          data-cy="applyButton"
          @click="debouncedApplyFilters"
        >
          {{ $t(item.label) }}
        </v-btn>
        <v-btn
          v-else-if="item.key === 'reset' && filters.length && filterName !== 'PricingManagement'"
          style="color: #26384B; margin-bottom: 30px"
          @click="debouncedClearFilters"
        >
          {{ $t(item.label) }}
        </v-btn>

        <v-checkbox
          v-if="item.type === 'checkbox'"
          v-model="item.value"
          class="mr-3"
          :label="$t('massBalance.pageName')"
          :data-cy="'checkbox-' + item.key"
          style="margin: 5px 40px 30px 20px !important;"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>

import { cloneDeep, debounce } from 'lodash';
import moment from 'moment';
import _datePickerLocales from '@/locales/date-picker-locales';
import VDate from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import autofocus from '@/utilities/directives/autofocus';


export default {
    name: 'SearchWithFilters',
    directives: {
        autofocus,
    },
    components: { VDate },
    props: {
        filters: {
            type: Array,
            default: () => [],
        },
        searchPlaceholder: {
            type: String,
            default: '',
        },
        withoutFilter: {
            type: Boolean,
            default: false,
        },
        hasDatesRange: {
            type: Boolean,
            default: false,
        },
        isDateMonth: {
            type: Boolean,
            default: false,
        },
        saveFilter: {
            type: Boolean,
            default: false,
        },
        showTextField: {
            type: Boolean,
            default: true,
        },
        filterName: {
            type: String,
            required: true,
            default: '',
        },
    },
    data() {
        return {
            filtersVisible: true,
            filterParams: {
            },
            debouncedSearch: debounce(this.onSearch, 500),
            debouncedApplyFilters: debounce(this.onApplyFilters, 500),
            debouncedClearFilters: debounce(this.onClearFilters, 500),
            search: '',
            mutableFilters: [],
            buttons: [
                {
                    key: 'search',
                    type: 'button',
                    label: 'billing.filter.apply',
                },
                {
                    key: 'reset',
                    type: 'button',
                    label: 'billing.filter.reset',
                },
            ],
            isMenuOpen: false,
            customLandscape: false,

            // Sample Registered
            samplesReceived: false,
        };
    },
    computed: {
        initialParams() {
            return this.getFiltersValues(cloneDeep(this.filters));
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
        dateRangeText() {
            const dateObject = this.mutableFilters.find(obj => obj.type === 'date');
            const dateFormatted = dateObject.value
                .map(date => this.$options.filters.formatDate(date, 'L'))
                .join(' ~ ');
            return dateFormatted;
        },
        samplesReceivedCheckBoxValue() {
            return this.samplesReceived;
        },
    },
    watch: {
        filters: {
            handler(newValue) {
                const clonedValues = cloneDeep(newValue) || [];
                this.mutableFilters = [...clonedValues, ...this.buttons];
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.updateCustomLandscape();
        window.addEventListener('resize', this.updateCustomLandscape);
        this.$nextTick(() => {
            const input = this.showTextField ? this.$refs.teamSearchInput.$el.querySelector('input') : null;
            if (input) input.focus();
        });
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateCustomLandscape);
    },
    methods: {
        onFilterClick() {
            this.filtersVisible = !this.filtersVisible;
        },
        getIsoDate(stringDate) {
            return stringDate ? new Date(stringDate).toISOString() : '';
        },
        getFiltersValues(filters = [], reset = false) {
            const params = {};
            // eslint-disable-next-line no-unused-expressions
            filters?.forEach(filter => {
                const selectedValue = filter.value;

                if (filter.type === 'button') {
                    params[filter.key] = reset ? '' : selectedValue;
                } else if ((filter.type === 'date' && filter.isRange) || filter.type === 'dateWithCheckbox') {
                    selectedValue.forEach((value, index) => {
                        params[filter.dateKeys[index]] = reset ? '' : this.getIsoDate(value);
                    });
                } else if ((filter.type === 'date' && !filter.isRange)) {
                    params[filter.dateKeys[0]] = reset ? '' : this.getIsoDate(selectedValue);
                } else {
                    params[filter.key] = reset ? '' : selectedValue;
                }
            });
            return params;
        },

        dateRangeInValid(params, keys) {
            return params[keys[0]] && params[keys[1]]
            && (!moment(params[keys[0]]).isSameOrBefore(params[keys[1]]));
        },

        onApplyFilters() {
            const params = cloneDeep(this.getFiltersValues(this.mutableFilters));
            if (params.startDate && !params.endDate && this.filters.isRange) {
                this.$toasted.global.toast_error({ message: this.$t('generic.endDateMissing') });
                return;
            }

            if (params.startDate && params.endDate) {
                const tz = moment.tz.guess();
                const startDateWithoutHour = params.startDate.split('T')[0];
                // start Date
                params.startDate = moment(startDateWithoutHour).tz(tz).format();

                // End date
                const endDateWithoutHour = params.endDate.split('T')[0];

                // on ajoute une journee pour aller à 00h00 le lendemain
                const endDate = moment(endDateWithoutHour).add(1, 'days');
                // Formater la nouvelle date
                params.endDate = moment(endDate).tz(tz).format();
            }

            if (params.collectedStartDate && params.collectedEndDate) {
                const tz = moment.tz.guess();
                const startDateWithoutHour = params.collectedStartDate.split('T')[0];
                // start Date
                params.collectedStartDate = moment(startDateWithoutHour).tz(tz).format();

                // End date
                const endDateWithoutHour = params.collectedEndDate.split('T')[0];

                // on ajoute une journee pour aller à 00h00 le lendemain
                const endDate = moment(endDateWithoutHour).add(1, 'days');
                // Formater la nouvelle date
                params.collectedEndDate = moment(endDate).tz(tz).format();
            }
            if (params.receivedStartDate && params.receivedEndDate) {
                if (!this.samplesReceivedCheckBoxValue) {
                    params.receivedStartDate = null;
                    params.receivedEndDate = null;
                } else {
                    const tz = moment.tz.guess();
                    const startDateWithoutHour = params.receivedStartDate.split('T')[0];
                    // start Date
                    params.receivedStartDate = moment(startDateWithoutHour).tz(tz).format();

                    // End date
                    const endDateWithoutHour = params.receivedEndDate.split('T')[0];


                    // on ajoute une journee pour aller à 00h00 le lendemain
                    const endDate = moment(endDateWithoutHour).add(1, 'days');

                    // Formater la nouvelle date
                    params.receivedEndDate = moment(endDate).tz(tz).format();
                }
            }

            if (
                this.dateRangeInValid(params, ['startDate', 'endDate'])
              || this.dateRangeInValid(params, ['collectedStartDate', 'collectedEndDate'])
              || this.dateRangeInValid(params, ['receivedStartDate', 'receivedEndDate'])
            ) {
                this.$toasted.global.toast_error({ message: this.$t('generic.dateRangeError') });
                return;
            }
            // if we select only 1 date , that means the range is only on this day
            if (!params.endDate && params.startDate) {
                params.endDate = this.filters.isRange ? params.startDate : null;
            }
            if (!params.collectedEndDate && params.collectedStartDate) params.collectedEndDate = moment().endOf('day').toISOString();
            if (!params.receivedEndDate && params.receivedStartDate) params.receivedEndDate = moment().endOf('day').toISOString();
            this.filterParams = { ...this.filterParams, ...params };
            this.$emit('onApplyFilters', this.filterParams);

            if (this.saveFilter && this.filterName?.length) {
                window.localStorage.setItem(this.filterName, JSON.stringify(this.filterParams));
            }
        },
        onClearFilters() {
            // First we reset filters
            this.mutableFilters = [
                ...cloneDeep(this.filters),
                ...this.buttons,
            ];

            const params = this.initialParams;
            this.search = '';
            this.$emit('onApplyFilters', { ...params, reset: true });
            if (this.saveFilter && this.filterName?.length) {
                window.localStorage.removeItem(this.filterName);
            }
            // When we clear filters we reset search too
            this.search = '';
        },
        onSearch(value) {
            this.$emit('onSearch', value);
        },
        updateCustomLandscape() {
            this.customLandscape = window.innerWidth > 600;
        },
        samplesReceivedChanged() {
            this.samplesReceived = !this.samplesReceived;
        },
    },
};
</script>
<style lang="scss" scoped>
  .filter--input__container {
    padding: 0px 12px;
  }
  .filter--input {
    margin-right: 5px;
  }
  .filter--date {
    margin-right: 5px;
  }
  .v-menu__content {
    margin-top: 5px !important;
}
</style>

<style lang="scss">
.blocFiltreAR {
  max-height: 43px;
  &__date {
    padding-top: 0;
    padding-bottom: 0;
    max-height: 43px;
    .v-input__control {
      height : 43px;
      .v-text-field__slot {
        max-height : 43px ;
      }
      fieldset {
        height: 43px;
      }
    }
    .v-input__prepend-inner {
      margin-top: 11px;
    }
  }
}

.searchWithFilters {

  .v-select__selections {
    flex-wrap: nowrap;
    max-width: calc(100% - 41px);
  }
  .v-select__slot > .v-input__append-inner > .v-input__icon > .v-icon  {
    transform: translateX(-10px);
  }

}


</style>
